import React, { useState, useEffect } from "react";
import { FaHome, FaRegFileAlt, FaGithub, FaLinkedin, FaSun, FaMoon } from "react-icons/fa";
import { LiaXing } from "react-icons/lia";

const navItems = [
  { href: "#home", icon: <FaHome size={22} />, label: "Home" },
  { href: "/sourav_resume.pdf", icon: <FaRegFileAlt size={22} />, label: "Resume", external: true },
  { href: "https://github.com/souravshetty", icon: <FaGithub size={22} />, label: "GitHub", external: true },
  { href: "https://www.linkedin.com/in/sourav-s-shetty/", icon: <FaLinkedin size={22} />, label: "LinkedIn", external: true },
];

const BottomNav = () => {
  const [dark, setDark] = useState(true);

  useEffect(() => {
    if (dark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [dark]);

  return (
    <nav className="fixed bottom-2 left-1/2 -translate-x-1/2 z-50 bg-white/90 dark:bg-gray-900/90 backdrop-blur-md rounded-full shadow-lg flex items-center justify-center px-2 py-2 gap-2 border border-gray-200 dark:border-gray-700 max-w-fit md:px-4 md:py-2 md:gap-3">
      {navItems.map((item, idx) => (
        <React.Fragment key={item.label}>
          <div className="relative group/tooltip">
            <a
              href={item.href}
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noopener noreferrer" : undefined}
              className="group p-2 rounded-full transition-colors duration-150 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-500 hover:text-white focus:bg-gradient-to-r focus:from-cyan-500 focus:to-blue-500 focus:text-white text-inherit dark:text-cyan-300 block"
              onClick={item.label === "Home" ? (e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); } : undefined}
            >
              {item.icon}
            </a>
            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1 bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 text-xs font-medium rounded-md opacity-0 group-hover/tooltip:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
              {item.label}
            </span>
          </div>
          {(idx === 0 || idx === 1) && (
            <span className="w-px h-6 bg-gray-200 dark:bg-gray-700 mx-1" />
          )}
        </React.Fragment>
      ))}
      <span className="w-px h-6 bg-gray-200 dark:bg-gray-700 mx-1" />
      <div className="relative group/tooltip">
        <button
          className="group p-2 rounded-full transition-colors duration-150 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-500 hover:text-white focus:bg-gradient-to-r focus:from-cyan-500 focus:to-blue-500 focus:text-white text-cyan-300"
          onClick={() => setDark((d) => !d)}
        >
          {dark ? <FaSun size={22} /> : <FaMoon size={22} />}
        </button>
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1 bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 text-xs font-medium rounded-md opacity-0 group-hover/tooltip:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
          Toggle Theme
        </span>
      </div>
    </nav>
  );
};

export default BottomNav; 